import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import {loadImageAsync} from '@Utils/image.util';
import {GridShapeThumb} from '@Components/base-grid/components/grid-shape-thumb/grid-shape-thumb';
import type {GridItemProps} from '../grid-item';
import type {GridMediaItemStorage} from '../grid-media-item';
import {GridMediaItem} from '../grid-media-item';

export interface GridShapeItemStorage extends GridMediaItemStorage {
  hashedFilename: string;
}

export interface GridShapeItemBackEndData {
  id: string;
  isHidden: boolean;
}

interface GridShapeItemProps extends GridItemProps {
  thumbSrc: string;
}

export function GridShapeItem({...props}: GridShapeItemProps): ReactElement {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    let isCancelled = false;
    const preloadThumbImage = async (): Promise<void> => {
      try {
        // Plain load (no CORS) — the same fetch mode the thumb <img> uses, so this warms its cache entry.
        await loadImageAsync(props.thumbSrc, false);
        if (!isCancelled) {
          setIsImageLoaded(true);
        }
      } catch {
        // Thumb failed to load; keep showing the skeleton background.
      }
    };
    void preloadThumbImage();
    return (): void => {
      isCancelled = true;
    };
  }, [props.thumbSrc]);

  return <GridMediaItem {...props} isImageLoaded={isImageLoaded} thumb={<GridShapeThumb className="" thumbSrc={props.thumbSrc} />} />;
}
